import { Typography } from '@mui/material';
import {
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_providerRate as ProviderRateType,
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_costimate as CostimateType,
} from 'src/__generated__/getSearchResults';
import { RATE_DURATION_ABBREVIATIONS, ServiceIdForMember } from '@/constants';
import { usePageAttributes } from '../../contexts/PageAttributesContext';

const RATE_TYPE = {
  PROVIDER_RATE: 'PROVIDER_RATE',
  COSTIMATE: 'COSTIMATE',
} as const;

export type RateType = typeof RATE_TYPE;

export type ProviderRateProps =
  | {
      providerRate: ProviderRateType;
      rateType: RateType['PROVIDER_RATE'];
    }
  | {
      providerRate: CostimateType;
      rateType: RateType['COSTIMATE'];
    };

export const ProviderRate = ({ rateType, providerRate }: ProviderRateProps) => {
  const { serviceIdForMember } = usePageAttributes();
  if (serviceIdForMember === ServiceIdForMember.HOUSING_LOCATION) {
    return null;
  }
  return (
    <Typography variant="h4">
      {rateType === 'PROVIDER_RATE'
        ? `Starting at $${providerRate.rate.amount}/${
            RATE_DURATION_ABBREVIATIONS[providerRate.rateDuration]
          }`
        : `Costimate: $${providerRate.rate.amount}/${
            RATE_DURATION_ABBREVIATIONS[providerRate.rateDuration]
          }`}
    </Typography>
  );
};
